/**
 * {@docCategory DetailsList}
 */
export var SelectAllVisibility;
(function (SelectAllVisibility) {
  SelectAllVisibility[SelectAllVisibility["none"] = 0] = "none";
  SelectAllVisibility[SelectAllVisibility["hidden"] = 1] = "hidden";
  SelectAllVisibility[SelectAllVisibility["visible"] = 2] = "visible";
})(SelectAllVisibility || (SelectAllVisibility = {}));